import { useEffect } from "react";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { colors } from "../../styles/color";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStaticDataDetails,
  setstatiDataState,
} from "../../redux/features/staticPage/staticSlice";
import { setLoading } from "../../redux/features/loader/loaderSlice";
import BreadCrumb from "../../components/common/BreadCrumb";
import { ToastMessage } from "../../helpers/ToastMessage";
import { useCookies } from "react-cookie";
import { setAppState } from "../../redux/features/appStateSlice";
import { ContactUs } from "./ContactUs";
import { Helmet } from "react-helmet-async";

interface MetaData {
  title?: string;
  description?: string;
  url?: string;
  ogImage?: string;
  ogUrl?: string;
  robots?: string;
  ogImageAlt?: string;
}

const HelpCategarys = () => {
  const { staticData } = useSelector((state: any) => state?.staticData);
  const params = useParams();
  const dispatch = useDispatch();
  const [token] = useCookies();
  const navigate = useNavigate();
  const location = useLocation();
  const isInfluencer = token.role === "2";
  const categary =
    params.categary === "privacy-policy"
      ? 1
      : params.categary === "terms-conditions"
      ? 2
      : params.categary === "data-safety"
      ? 3
      : params.categary === "disclaimer"
      ? 4
      : params.categary === "about-us"
      ? 5
      : params.categary === "dmcapolicy"
      ? 6
      : 7;

  const title =
    categary === 1
      ? "Privacy Policy"
      : categary === 2
      ? "Terms & Conditions"
      : categary === 3
      ? "Data Safety"
      : categary === 4
      ? "Disclaimer"
      : categary === 5
      ? "About Us"
      : categary === 6
      ? "DMCA Policy"
      : "Contact Us";
  useEffect(() => {
    dispatch(setAppState("other"));
    if (categary !== 7) {
      dispatch(setLoading(true));
      const getStaticData = async () => {
        let obj = {
          type: isInfluencer ? 2 : 3,
          page:
            categary === 1
              ? "privacy"
              : categary === 2
              ? "terms"
              : categary === 3
              ? "safety"
              : categary === 4
              ? "disclaimer"
              : categary === 5
              ? "aboutus"
              : categary === 6
              ? "dmcapolicy"
              : 7,
        };
        const res = await dispatch(fetchStaticDataDetails(obj));
        if (res?.error) {
          ToastMessage({
            type: "error",
            message: res.error.message,
          });
        }
        dispatch(setstatiDataState(res?.payload));
      };
      getStaticData();
      setTimeout(() => {
        dispatch(setLoading(false));
      }, 1000);
    }
  }, [categary, dispatch]);

  const metaData: Record<number, MetaData> = {
    1: {
      title: " Quickfluence Dashboard: Complete Privacy Policy Details",
      description:
        "Review the Quickfluence privacy policy to learn how we manage data collection, usage, cookies, sharing and security, keeping you informed about your rights.",
      url: "https://quickfluence.com/",
      ogImage:
        "https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png",
      ogUrl: "https://quickfluence.com/",
      robots: "noindex, nofollow",
      ogImageAlt: "Quickfluence privacy policy dashboard page",
    },
    2: {
      title: "Quickfluence Dashboard: Terms and Conditions Guide",
      description:
        "Review Quickfluence’s Terms and Conditions for clear policies that support creators and brands. Ensure transparent, fair, and secure influencer partnerships.",
      url: "https://quickfluence.com/",
      ogImage:
        "https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png",
      ogUrl: "https://quickfluence.com/",
      robots: "noindex, nofollow",
      ogImageAlt: "Quickfluence dashboard Terms and Conditions page",
    },
    3: {
      title: "Quickfluence Dashboard: Data Safety Guidelines Page",
      description:
        "Protect your data with Quickfluence using encryption, access controls, secure storage, audits, payment protection, authentication and privacy compliance.",
      url: "https://quickfluence.com/",
      ogImage:
        "https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png",
      ogUrl: "https://quickfluence.com/",
      robots: "noindex, nofollow",
      ogImageAlt: "Quickfluence data safety and security dashboard",
    },

    4: {
      // Disclaimer
      title: "QuickFluence Disclaimer for Influencer Collaboration Use",
      description:
        "Read the QuickFluence disclaimer for influencer collaborations. Learn how our platform supports brands and creators and outlines key responsibilities.",
      url: "https://quickfluence.com/disclaimer",
      ogImage:
        "https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png",
      ogUrl: "https://quickfluence.com/disclaimer",
      robots: "noindex, nofollow",
      ogImageAlt:
        " Disclaimer page for QuickFluence brand and creator platform",
    },
    5: {
      // About Us
      title: "Your Trusted Influencer Collaboration Partner | QuickFluence",
      description:
        "Explore QuickFluence, a powerhouse for influencer collaborations that helps brands and creators connect, grow, and build partnerships globally and more.",
      url: "https://www.quickfluence.com/about-us",
      ogImage:
        "https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png",
      ogUrl: "https://quickfluence.com/about-us",
      robots: "index, follow",
      ogImageAlt:
        "QuickFluence influencer collaboration and brand partnership platform",
    },
    6: {
      // DMCA Policy
      title: "  DMCA Policy | Protecting Your Content at Quickfluence",
      description:
        "Read the Quickfluence DMCA Policy to understand how we protect creator content, handle infringement claims, and support safe influencer collaborations.",
      url: "https://quickfluence.com/dmcapolicy",
      ogImage:
        "https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png",
      ogUrl: "https://quickfluence.com/dmcapolicy",
      robots: "noindex, nofollow",
      ogImageAlt: "Quickfluence DMCA policy banner for Safe Content Protection",
    },
    7: {
      // Contact Us
      title: "Contact QuickFluence for Influencer Brand collaboration",
      description:
        "Contact QuickFluence for influencer collaboration. Reach out for brand partnerships, creator enquiries, campaign help, and platform assistance anytime.",
      url: "https://quickfluence.com/contact-us",
      ogImage:
        "https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png",
      ogUrl: "https://quickfluence.com/contact-us",
      robots: "index, follow",
      ogImageAlt:
        "Contact QuickFluence for brand and creator collaboration partnership",
    },
  };
  const isDashboard = location.pathname.startsWith("/dashboard");
  const shouldSetMetaData =
    [4, 5, 6, 7].includes(categary) ||
    (isDashboard && [1, 2, 3].includes(categary));
  const currentMeta = metaData[categary as keyof typeof metaData];

  return (
    <>
      {!isDashboard && params.categary === "terms-conditions" && (
        <Helmet>
          <title>Terms & Conditions Page | Quickfluence</title>
          <meta
            name="description"
            content="Read the Quickfluence Terms and Conditions to learn platform rules, user duties, content policies, and guidelines for influencer collaborations today!!!"
          />
          {/* Canonical */}
          <link
            rel="canonical"
            href="https://quickfluence.com/terms-conditions"
          />
          {/* Open Graph */}
          <meta
            property="og:title"
            content="Quickfluence Terms and Conditions | User Guidelines"
          />
          <meta
            property="og:description"
            content="Read the Quickfluence Terms and Conditions to learn platform rules, user duties, content policies, and guidelines for influencer collaborations today!!!"
          />
          <meta
            property="og:url"
            content="https://quickfluence.com/terms-conditions"
          />
          <meta property="og:site_name" content="quickfluence" />
          <meta property="og:type" content="website" />
          <meta property="og:locale" content="en" />
          <meta
            property="og:image"
            content="https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png"
          />
          <meta
            property="og:image:alt"
            content="Quickfluence terms and conditions page"
          />

          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta name="robots" content="index, follow" />
        </Helmet>
      )}

      {!isDashboard && params.categary === "privacy-policy" && (
        <Helmet>
          <title>
            Quickfluence Policy & Data Protection | Your Privacy Matters
          </title>
          <meta
            name="description"
            content="Read the Quickfluence Privacy Policy to see how we collect, use, and protect your data while ensuring transparency, user trust, and secure collaborations."
          />
          {/* Canonical */}
          <link
            rel="canonical"
            href="https://quickfluence.com/privacy-policy"
          />
          {/* Open Graph */}
          <meta
            property="og:title"
            content="Quickfluence Privacy Policy | How We Collect and Use Data"
          />
          <meta
            property="og:description"
            content="Read the Quickfluence Privacy Policy to see how we collect, use, and protect your data while ensuring transparency, user trust, and secure collaborations."
          />
          <meta
            property="og:url"
            content="https://quickfluence.com/privacy-policy"
          />
          <meta property="og:site_name" content="quickfluence" />
          <meta property="og:type" content="website" />
          <meta property="og:locale" content="en" />
          <meta
            property="og:image"
            content="https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png"
          />
          <meta
            property="og:image:alt"
            content="Quickfluence privacy policy page"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta name="robots" content="index, follow" />
        </Helmet>
      )}

      {!isDashboard && params.categary === "data-safety" && (
        <Helmet>
          <title>
            Data Security & Privacy Protection for Influencers & Brands
          </title>
          <meta
            name="description"
            content="Discover how Quickfluence protects your data with advanced security, encrypted systems, and transparent practices to ensure safe and secure collaboration."
          />

          {/* Canonical */}
          <link rel="canonical" href="https://quickfluence.com/data-safety" />

          {/* Open Graph */}
          <meta
            property="og:title"
            content="Quickfluence Data Safety | How We Protect Your Information"
          />
          <meta
            property="og:description"
            content="Discover how Quickfluence protects your data with advanced security, encrypted systems, and transparent practices to ensure safe and secure collaboration."
          />
          <meta
            property="og:url"
            content="https://quickfluence.com/data-safety"
          />
          <meta property="og:site_name" content="quickfluence" />
          <meta property="og:type" content="website" />
          <meta property="og:locale" content="en" />
          <meta
            property="og:image"
            content="https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png"
          />
          <meta
            property="og:image:alt"
            content="Quickfluence data safety page"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta name="robots" content="index, follow" />
        </Helmet>
      )}
      {shouldSetMetaData && currentMeta && (
        <Helmet>
          {/* Only render title if it exists */}
          {currentMeta.title && <title>{currentMeta.title}</title>}

          {/* Only render description if it exists */}
          {currentMeta.description && (
            <meta name="description" content={currentMeta.description} />
          )}

          {/* Only render canonical URL if it exists */}
          {currentMeta.url && <link rel="canonical" href={currentMeta.url} />}

          {/* Only render Open Graph image if it exists */}
          {currentMeta.ogImage && (
            <meta property="og:image" content={currentMeta.ogImage} />
          )}

          {/* Only render Open Graph URL if it exists */}
          {currentMeta.ogUrl && (
            <meta property="og:url" content={currentMeta.ogUrl} />
          )}

          {/* Only render robots meta if it exists */}
          {currentMeta.robots && (
            <meta name="robots" content={currentMeta.robots} />
          )}

          {/* Only render og:image:alt if it exists and has content */}
          {currentMeta.ogImageAlt && (
            <meta property="og:image:alt" content={currentMeta.ogImageAlt} />
          )}

          {/* Additional Open Graph tags that are commonly used */}
          {currentMeta.title && (
            <meta property="og:title" content={currentMeta.title} />
          )}
          {currentMeta.description && (
            <meta property="og:description" content={currentMeta.description} />
          )}
          <meta property="og:type" content="website" />
        </Helmet>
      )}

      <Box
        sx={{
          "& .MuiAppBar-root": {
            position: "sticky",
          },
        }}
      >
        {isInfluencer ? (
          <BreadCrumb
            isClickable={true}
            name1={"Settings"}
            name2={title}
            onClick={() => {
              dispatch(setstatiDataState({}));
              navigate("/dashboard/Settings");
            }}
          />
        ) : (
          <Typography
            sx={{
              marginTop: "32px",
              fontSize: "22px",
            }}
            mb={2.5}
            variant="h1"
          >
            {title}
          </Typography>
        )}

        <Box sx={isInfluencer ? { p: "0px 16px", mt: "16px", mb: "16px" } : {}}>
          <Box
            bgcolor={colors.dark[800]}
            borderRadius={"12px"}
            overflow="hidden"
          >
            <Box
              sx={{
                "&::-webkit-scrollbar": {
                  width: 0,
                },
                mt: isInfluencer ? { sm: "50px", xs: "30px" } : {},
                mb: "20px",
                borderRadius: "12px",
                height: isInfluencer
                  ? { sm: "calc(100vh - 230px)", xs: "calc(100vh - 200px)" }
                  : "100%",
                overflow: "auto",
                color: "white",
                maxWidth: isInfluencer ? "auto" : "926px",
                margin: "auto",
                p: isInfluencer
                  ? {
                      md: "0px 60px 30px 60px",
                      xs: "0px 30px 20px 30px",
                    }
                  : {
                      xs: "0px 15px",
                    },
                "& .MuiTypography-root": {
                  "&:nth-of-type(odd)": {
                    color: colors.basics.white,
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: 16,
                    lineHeight: "150%",
                  },
                  "&:nth-of-type(even)": {
                    color: colors.gray[300],
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: 15,
                    lineHeight: "180%",
                  },
                },
              }}
            >
              <Box>
                <Box></Box>
                <Box mb="119px">
                  {categary !== 7 ? (
                    <Typography
                      dangerouslySetInnerHTML={{
                        __html: staticData?.data?.description,
                      }}
                    />
                  ) : (
                    <ContactUs />
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HelpCategarys;
